// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import type { Element } from 'react';
import PropTypes from 'prop-types';

// Components
import Button from 'Common/Button';
import Carousel from 'Common/Carousel';
// Helpers
import styles from 'components/QuickLinks.scss';
import classNames from 'classnames';

type DefaultProps = {
  extendStyle: string,
  quickLinksData: Array<empty>,
  viewport: string
};

/**
 * QuickLinks React component.
 */
class QuickLinks extends PureComponent<*, *> {
  /**
   *  Props implementation.
   */
  static propTypes = {
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    quickLinksData: PropTypes.array,
    viewport: PropTypes.string
  };

  /**
   *  Default Props implementation.
   */
  static defaultProps: DefaultProps = {
    quickLinksData: []
  };

  /**
   * Props implementation.
   * @param {object} props - component props
   */
  constructor(props: Object) {
    super(props);
    this.state = {};
  }

  /**
   * componentDidUpdate implementation.
   * @param {object} prevProps - component props
   * @param {object} prevState - component state
   */
  componentDidUpdate(prevProps: Object, prevState: Object) {}

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object) {
    return {
      viewport: state.viewport.viewport
    };
  }

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const {
      classQuickLinksContainer,
      classQuickLinksButton,
      classQuickLinksCarousel
    } = styles;

    const { extendStyle, quickLinksData, viewport } = this.props;
    const carouselItemsToDisplay = { xs: 2, sm: 4, md: 4, lg: 6 };
    return (
      <div className={classNames([extendStyle, classQuickLinksContainer])}>
        {quickLinksData.length > 0 ? (
          <Carousel
            itemsToDisplay={carouselItemsToDisplay[viewport]}
            carouselType="lightSlider"
            showPagination={false}
            extendStyle={classQuickLinksCarousel}
          >
            {quickLinksData.map((link, index) => (
              <Button
                key={`${index}-links`}
                dataSection="quickLinks"
                extendStyle={classQuickLinksButton}
                buttonText={link.label}
                href={link.href}
                attributeTarget={'_self'}
              />
            ))}
          </Carousel>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(QuickLinks.mapStateToProps, null)(QuickLinks);



// WEBPACK FOOTER //
// ./src/Common/QuickLinks/index.js